<script>
import NrTooltip from '../NrTooltip/NrTooltip.vue'
import NrIconButton from '../NrIconButton/nr-icon-button.vue'

export default {
  components: { NrTooltip, NrIconButton },
  computed: {
    showTooltip() {
      return this.$slots.tip?.() && this.$slots.tip?.().length
    }
  }
}
</script>

<template>
  <label class="nr-form-label" v-bind="$attrs">
    <span class="nr-form-label__text"><slot></slot></span>
    <NrTooltip v-if="showTooltip" trigger="mouseenter click">
      <NrIconButton
        size="small"
        variant="minimal-neutral"
        aria-label="More information"
        :icon="{ name: 'info-circle' }"
      />
      <template v-slot:label><slot name="tip"></slot></template>
    </NrTooltip>
  </label>
</template>

<style lang="scss">
@import '../../styles/tokens/tokens.scss';

.nr-form-label {
  display: inline-flex;
  align-items: center;

  .nr-form-label__text {
    @include body-default-strong;
    color: $color-purple-110;
    line-height: calc($font-lineheight-3 + $border-width-medium);
  }

  .nr-tooltip {
    display: block;
    margin-left: $spacing-4;
  }

  .nr-tooltip__trigger {
    display: block;
  }

  .nr-icon-button {
    display: block;
  }
}
</style>
